// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"OL","backgroundimage":"PL","header":"QL","headerwrap":"RL","title":"SL","promomessage":"TL","upsellItem":"UL","upsellImg":"VL","helperText":"WL","upsellHeadline":"XL","price":"YL","upsellGross":"ZL","upsellNet":"aM","upsellButton":"bM","nutritionfacts":"cM","nutritionimg":"eM","containerwhy":"fM","nutritionwrappwer":"gM","headlinewhy":"hM","boxwhy":"iM","textwhy":"jM","backbutton":"kM","drawercontainer":"lM","logoheader":"mM","textwrap":"nM","timer":"oM"};
    if(module.hot) {
      // 1713361653740
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  